import { Table } from 'antd';
import { format } from 'date-fns';
import React from 'react'
import { useEffect } from 'react';
import { useState } from 'react';
import { v4 as uuidv4 } from "uuid";
import axios from '../../api/axios';
import { formatDate, sortArray } from '../../utils/utils';
import { es } from 'date-fns/locale'
import { actividades, emptyOption } from '../../constants/form';
import ReactSelect from 'react-select';
import { stylesReactSelect } from '../select/styles';
import EditTurnDate from '../editTurnDate/EditTurnDate';
import { Button } from 'react-bootstrap';
import { useCallback } from 'react';

const columns = [
  {
    title: <span className='weektable-th'>Horario</span>,
    dataIndex: 'horario',
    key: 'horario',
    render: (e) => {
      return (
        <span className='weektable-horary'>
          {e}
        </span>
      )
    }
  },
  {
    title: <span className='weektable-th'>Lunes</span>,
    dataIndex: 'lunes',
    key: 'lunes',
    render: (e) => {
      return (
        <span className='weektable-day'>
          {e}
        </span>
      )
    }
  },
  {
    title: <span className='weektable-th'>Martes</span>,
    dataIndex: 'martes',
    key: 'martes',
    render: (e) => {
      return (
        <span className='weektable-day'>
          {e}
        </span>
      )
    }

  },
  {
    title: <span className='weektable-th'>Miércoles</span>,
    dataIndex: 'miércoles',
    key: 'miércoles',
    render: (e) => {
      return (
        <span className='weektable-day'>
          {e}
        </span>
      )
    }

  },
  {
    title: <span className='weektable-th'>Jueves</span>,
    dataIndex: 'jueves',
    key: 'jueves',
    render: (e) => {
      return (
        <span className='weektable-day'>
          {e}
        </span>
      )
    }
  },
  {
    title: <span className='weektable-th'>Viernes</span>,
    dataIndex: 'viernes',
    key: 'viernes',
    render: (e) => {
      return (
        <span className='weektable-day'>
          {e}
        </span>
      )
    }

  },
  {
    title: <span className='weektable-th'>Acciones</span>,
    dataIndex: 'acciones',
    key: 'acciones'
  },
]


const WeekTable = () => {
  const [data, setData] = useState([]);
  const [showData, setShowData] = useState([]);
  const [filter, setFilter] = useState("");

  const [show, setShow] = useState(false);
  const [date, setDate] = useState(false);

  useEffect(() => {
    if (data?.length) {
      let resultFilter = data?.filter(e => {
        if (e.actividad.includes(filter)) {
          return true;
        }
        else {
          return false;
        }
      });

      setShowData(sortArray(resultFilter));
    } else {
      setShowData([]);
    }
  }, [data, filter]);


  const formatDates = (date) => {
    return format(new Date(formatDate(date)), 'EEEE', { locale: es })
  }

  const handleClick = (row) => {
    setDate(row)
    setShow(true);
  }


  const getData = useCallback(async () => {
    try {
      let response = await axios.get("turns/getDatesByActivity");
      if (response.data) {
        let formatData = response?.data?.reduce((a, b) => {
          if (a[formatDates(b.fecha)]) {
            if (a[formatDates(b.fecha)][b?.restriccion?.unidad?.name]) {
              a[formatDates(b.fecha)][b?.restriccion?.unidad?.name] = [
                ...a[formatDates(b.fecha)][b?.restriccion?.unidad?.name],
                {
                  fecha: b.fecha,
                  horarios: b.horario,
                  id: b.id,
                  id_restriccion: b?.restriccion?.id,
                  actividad: b?.restriccion?.unidad?.name,
                  dia: formatDates(b.fecha)
                }
              ]
              return a;
            }
            else {
              a[formatDates(b.fecha)] = {
                ...a[formatDates(b.fecha)],
                [b?.restriccion?.unidad?.name]: [
                  {
                    fecha: b.fecha,
                    horarios: b.horario,
                    id: b.id,
                    id_restriccion: b?.restriccion?.id,
                    actividad: b?.restriccion?.unidad?.name,
                    dia: formatDates(b.fecha)
                  }
                ]
              };
              return a;
            }

          } else {
            a[formatDates(b.fecha)] = {
              [b?.restriccion?.unidad?.name]: [
                {
                  fecha: b.fecha,
                  horarios: b.horario,
                  id: b.id,
                  id_restriccion: b?.restriccion?.id,
                  actividad: b?.restriccion?.unidad?.name,
                  dia: formatDates(b.fecha)
                }
              ]
            }

            return a
          }
        }, {})

        let keys = Object.keys(formatData);

        let result = keys.map(e => {
          let b_keys = Object.values(formatData[e]);

          let b_values = b_keys.map(c => {
            let horaries = c.reduce((a, b) => {
              if (a.length) {
                if (a.some(e => e.horario === b.horarios)) {
                  return a.map(g => {
                    if (g.horario === b.horarios) {
                      return {
                        ...g,
                        ids: [...g.ids, b.id],
                        dia: e,
                        actividad: b.actividad,
                        [e]: b.actividad,
                      }
                    } else {
                      return g
                    }
                  })
                } else {
                  return [
                    ...a,
                    {
                      horario: b.horarios,
                      ids: [b.id],
                      dia: e,
                      actividad: b.actividad,
                      [e]: b.actividad,
                    }
                  ]
                }
              }
              else {
                return [
                  {
                    horario: b.horarios,
                    ids: [b.id],
                    dia: e,
                    actividad: b.actividad,
                    [e]: b.actividad,
                    id_restriccion: b.id_restriccion
                  }
                ]
              }
            }, [])


            return horaries;
          })

          return b_values.flat();
        })

        let resultData = sortArray(result.flat());

        setData(resultData);
        setShowData(resultData);
      } else {
        setData([]);
      }
    } catch (err) {
      console.log(err);
    }
  }, []);

  useEffect(() => {
    getData();
  }, [getData]);

  const formatData = (array) => {
    try {
      if (array?.length) {
        return array.map(e => {
          const { dia, actividad } = e;
          return {
            ...e,
            [dia]: actividad,
            acciones: <div>
              <Button onClick={() => handleClick(e)}>Cambiar día</Button>
            </div>
          }
        })
      } else {
        return [];
      }
    }
    catch (err) {
      console.log(err);
      return []
    }
  };


  const handleChange = (e) => {
    setFilter(e.value);
  }

  return (
    <div>
      <div className='my-5 mx-3'>
        <h5 className='form-subtitle'>Seleccionar actividad</h5>

        <ReactSelect
          options={actividades?.length ? [emptyOption, ...actividades] : [emptyOption]}
          styles={stylesReactSelect}
          onChange={handleChange}

          defaultValue={actividades[0]}
        />
      </div>
      <div>
        <Table
          columns={columns}
          dataSource={formatData(showData)}
          rowKey={() => uuidv4()}
        />
      </div>
      {show ? <EditTurnDate show={show} handleClose={() => setShow(false)} data={data} date={date} getData={getData} /> : ""}
    </div>
  )
};

export default WeekTable;